import React, { Component } from 'react';
import * as Sentry from '@sentry/react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (typeof Sentry === 'undefined') {
      return;
    }
    Sentry.configureScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
    });
    Sentry.captureException(error);
    // Sentry.captureReactException(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // render fallback UI
      return this.props.fallback || <div>Something went wrong!</div>;
    }

    // when there's not an error, render children untouched
    return this.props.children;
  }
}
